<template>
	<v-container grid-list-md text-xs-right>
		<v-form ref="form" class="xs12">
			<v-layout row wrap>
				<template>
					<v-flex xs12 md6>
						<v-text-field light lazy filled v-model="groupDetail.name" :label="$t('groups.table.name')"></v-text-field>
					</v-flex>
				</template>
			</v-layout>
		</v-form>
		<v-btn color="primary"
			   :loading="isSaving"
			   @click="save()">
			{{ $t('save') }}
		</v-btn>
		<v-btn class="ma-1" color="secondary" v-if="isNewGroup"
			   @click.prevent="showConfirmDeleteDialog = true">
			{{ $t('remove') }}
		</v-btn>
		<confirm-delete-dialog v-model="showConfirmDeleteDialog"
							   :body="$t('confirm-delete.body-subject', {subject: groupDetail.name})"
							   @remove="removeGroup"></confirm-delete-dialog>
	</v-container>
</template>

<script>
	import { mapState } from 'vuex';
	import ConfirmDeleteDialog from '@/components/dialogs/confirm-delete-dialog';

	export default {
		name: 'GroupsTableItem',
		components: { ConfirmDeleteDialog },
		props: {
			group: {
				type: Object,
			}
		},
		data() {
			return {
				showConfirmDeleteDialog: false,
				groupDetail: {}
			};
		},
		computed: {
			...mapState({
				isSaving: state => state.group.isSavingGroup
			}),
			isNewGroup() {
				return !!this.groupDetail._id;
			}
		},
		mounted() {
			this.groupDetail = JSON.parse(JSON.stringify(this.group));
		},
		methods: {
			save() {
				if (this.groupDetail._id) {
					this.$emit('updateGroup', this.groupDetail);
				} else {
					this.$emit('createGroup', this.groupDetail);
				}
			},
			removeGroup() {
				this.$emit('removeGroup', this.groupDetail._id);
			}
		}
	};
</script>

<style lang="scss" scoped>
	@import "@/styles/colors";

	.cards {
		background-color: $background-grey !important;
		border-radius: 10px;
		display: flex;
		flex-direction: column;
		justify-content: center;
		width: 250px;
		height: 250px;
		margin: 10px;
		text-align: center;

		&:hover {
			background-color: $light-grey !important;
		}
	}

	.remove-button {
		position: absolute;
		top: 5px;
		right: 5px;
	}
</style>
